import axios from "axios";


export class UsuarioService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend"}`;

    static getALLUsuarios() {
        let dataURL = `${this.serverURL}/usuarios`;
        // console.log('dataURL.usuario');
        //  console.log(dataURL);
            return axios.get(dataURL);
           
    }
    
    static getUsuario(usuarioId){
        let dataURL = `${this.serverURL}/usuario/${usuarioId}`;
        
            return axios.get(dataURL, {headers: {Authorization: 'Bearer undefined'}} )
    }
    static getUsuarioEmail(userEmail){
        let dataURL = `${this.serverURL}/usuario_email/${userEmail}`;
        console.log('user_email');
         console.log(dataURL);
            return axios.get(dataURL);
    }

    static createUsuario(usuario){
        let dataURL = `${this.serverURL}/usuario/`;
        console.log('dataURL.usuario');
        console.log(dataURL,usuario);
        return axios.post(dataURL, usuario);
    }
       

    static updateUsuario(usuario, usuarioId){
        let dataURL = `${this.serverURL}/usuario/${usuarioId}`;
        return axios.put(dataURL, usuario)
    }

    static deleteUsuario(usuarioId){
        let dataURL = `${this.serverURL}/usuario/${usuarioId}`;
        return axios.delete(dataURL);
    }

    static loginUsuario(login){
        let dataURL = `${this.serverURL}/login`;
        console.log('dataURL.usuario');
        console.log(dataURL,login);
        return axios.post(dataURL,login);
    }
       


}